<template>
  <div class="content-wrapper">
    <CircleBadge />
    <ContentHome />
    <ContentOsteopathie />
    <ContentBehandlung />
    <ContentUeberMich />
    <ContentKontakt />
  </div>
</template>
<script>
import ContentHome from "./ContentHome"
import ContentOsteopathie from "./ContentOsteopathie"
import ContentBehandlung from "./ContentBehandlung"
import ContentUeberMich from "./ContentUeberMich"
import ContentKontakt from "./ContentKontakt"
import CircleBadge from './CircleBadge.vue'

export default {
    name: "ContentWrapper",
    components: {
        ContentHome,
        ContentOsteopathie,
        ContentBehandlung,
        ContentUeberMich,
        ContentKontakt,
        CircleBadge
    }
}
</script>

<style>
section {
    margin-bottom: 100px;
}
section:first-of-type, section:last-of-type {
  min-height: 600px;
  margin-top: 225px;
}

@media (min-width: 576px) {
  section:first-of-type {
    margin-top: 300px;
  }
}
.content-wrapper {
    margin-top: 150px;
}
</style>

